export default "/images/vendor/flag-icon-css/flags/1x1/si.svg?d38938fcbf4ff943085655e60cd4899d";